export const companyCultureState = {
  addModal: false,
  submitting: false,
};

export const companyCultureReducer = (state, action) => {
  switch (action.type) {
    case "setAddModal":
      return { ...state, addModal: action.value };
    default:
      return state;
  }
};
